var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},_vm._l((5),function(i){return _c('UserLetter',{key:i,attrs:{"order":i,"letter":_vm.words[_vm.line][i-1],"currentLine":_vm.currentLine,"hint":_vm.hints[i-1],"showHint":_vm.showHint}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }